import {type EndGameData} from '@colonist/game-base-types'
import {type TranslationObject} from '@colonist/i18n'
import {type NonFunctionProperties} from '@colonist/types'
import {BaseRankedUserState, RankedUserStateType} from './BaseRankedUserState.ts'

export class RankedPlacementState extends BaseRankedUserState {
    readonly type = RankedUserStateType.Placement

    readonly numberOfPlacementGamesFinished: number
    readonly numberOfPlacementGamesRequired: number
    readonly defaultEndGameData: EndGameData

    constructor(numberOfPlacementGamesFinished: number, numberOfPlacementGamesRequired: number) {
        super()
        this.numberOfPlacementGamesFinished = numberOfPlacementGamesFinished
        this.numberOfPlacementGamesRequired = numberOfPlacementGamesRequired
        this.defaultEndGameData = {
            amount: '-',
            highest: false,
        }
    }

    finishedPlacementGames(): boolean {
        return this.numberOfPlacementGamesFinished >= this.numberOfPlacementGamesRequired
    }

    getEndGameScreenText() {
        const remainingGames = this.numberOfPlacementGamesRequired - this.numberOfPlacementGamesFinished

        const title: TranslationObject = {
            key: 'strings:game.endGame.rankedUpdate.placementTitle',
            options: {
                gamesPlayedCount: this.numberOfPlacementGamesFinished,
                requiredGamesCount: this.numberOfPlacementGamesRequired,
            },
        }

        const description: TranslationObject = {
            key: 'strings:game.endGame.rankedUpdate.placementDescription',
            options: {
                count: remainingGames,
            },
        }

        return {
            title: title,
            description: description,
        }
    }

    getEndGameData(): EndGameData {
        return this.defaultEndGameData
    }

    getFindGamePopupStatusText(): TranslationObject {
        return {
            key: 'strings:colonistCommon.rankedState.placementGamesPlayed',
            options: {
                gamesPlayedCount: this.numberOfPlacementGamesFinished,
                count: this.numberOfPlacementGamesRequired,
            },
        }
    }

    static deserialize(data: NonFunctionProperties<RankedPlacementState>): BaseRankedUserState {
        const newPlacementState = new RankedPlacementState(data.numberOfPlacementGamesFinished, data.numberOfPlacementGamesRequired)
        return newPlacementState
    }
}
